var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.31 13.025c-.645-3.251 2.44-5.158 2.44-5.158s-1.202-1.739-3.222-2.186c-2.02-.449-3.03.111-4.04.532-1.01.42-1.513.42-1.513.42-1.457 0-2.522-1.542-5.299-.84-1.912.483-3.926 2.691-4.29 5.326-.363 2.637.422 6 1.935 8.607 1.514 2.61 3.056 3.59 4.15 3.618 1.095.027 2.187-.784 3.504-.981 1.318-.196 2.13.477 3.422.841 1.288.363 1.74.026 3.223-1.235 1.488-1.262 2.834-4.88 2.834-4.88s-2.497-.811-3.143-4.064Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 3.861c1.432-1.458.947-3.715.947-3.715s-2.01.353-3.356 1.753c-1.345 1.402-1.122 3.616-1.122 3.616s2.1-.196 3.532-1.653Z",
    fill: "#fff"
  })));
};
export default SvgApple;